module.exports = __webpack_public_path__ + "static/media/gauge.fc304624.svg";